import { merge } from 'lodash';

import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import WebsocketClient from 'websocket/client';

export const displayNoticeFlash = () => {
  if (window.AlumniConnect.flash_notice_message !== '') {
    if (typeof window.AlumniConnect.flash_notice_message === 'string') {
      toast.success(window.AlumniConnect.flash_notice_message);
    }

    window.AlumniConnect.flash_notice_message = '';
  }
};

export const displayAlertFlash = () => {
  if (window.AlumniConnect.flash_alert_message !== '') {
    if (typeof window.AlumniConnect.flash_alert_message === 'string') {
      toast.error(window.AlumniConnect.flash_alert_message);
    }

    window.AlumniConnect.flash_alert_message = '';
  }
};

export const hidePageLoader = () => {
  const handleTransitionEnd = () => (el.style.display = 'none');

  const el = document.querySelector('[data-behavior="page-loader"]');

  el.addEventListener('transitionend', handleTransitionEnd);
  el.addEventListener('transitioncancel', handleTransitionEnd);

  el.style.opacity = 0;
};

export const setData = (data) => {
  window.AlumniConnect.currentSession = {
    ...data.session_info,
    linkedin_oauth2_token_expires_at: new Date(
      data.session_info?.linkedin_oauth2_token_expires_at,
    ),
  };
  window.AlumniConnect.currentUser = data.user;
  window.AlumniConnect.currentNetwork = data.network;
  window.AlumniConnect.Helpers.LoggedAs = data.logged_as;
  window.AlumniConnect.other_infos = data.other_infos;

  window.Hivebrite.data = {};
  window.Hivebrite.data.jwt = data.jwt;
  window.Hivebrite.data.access_token = data.access_token;
};

export const getSessionInfo = ({
  cancelToken = undefined,
  type,
  options,
} = {}) =>
  axios.get(
    Routes.session_info_path({
      format: 'json',
    }),
    {
      cancelToken: cancelToken?.token,
      params: {
        type,
        options,
      },
    },
  );

export const fetchDatas = () =>
  Promise.all([
    // Fetch session_info datas
    // DO NOT ADD BACK "page_customizables" SINCE THE MENU DATA FETCH/DISPLAY IS ASYNC TO NOT BLOCK THE SPA FIRST RENDER.
    Promise.all([
      getSessionInfo({ type: 'network', options: ['common_nodes'] }),
      getSessionInfo({
        type: 'network',
        options: ['network_configuration'],
      }),
      getSessionInfo({
        type: 'network',
        options: ['user_fields_config'],
      }),
      getSessionInfo({ type: 'user' }),
      getSessionInfo({ type: 'other_infos', options: ['common_nodes'] }),
      getSessionInfo({ type: 'common' }),
    ]).then((datas) => ({
      sessionInfo: datas.reduce(
        (result, { data }) => merge({}, result, data),
        {},
      ),
    })),
  ])
    .then((datas) => {
      const data = datas.reduce(
        (result, data) => ({
          ...data,
          ...result,
        }),
        {},
      );

      // Podcast to window parent
      window.parent.postMessage('Login success', '*');

      // Send message login message to mobile app
      if (window.mobileBridge) {
        window.mobileBridge.jsMessage('login');
      }

      // Set some global datas
      setData(data.sessionInfo);

      if (!window.__WEBSOCKET_DEACTIVATION__) {
        WebsocketClient.subscribe([
          'flash_messages',
          'internal_notifications',
          'internal_messaging',
          'messaging_channel',
        ]);
        window.Hivebrite.wsState = WebsocketClient.wsState;
      }

      return data;
    })
    .catch(() =>
      // if we can't get session info, make sur the last accessed page
      // that needs authentifcation, is front#index for devise to
      // redirect us ther after login
      axios.get('/'),
    );
